<!--  this div used to show  extra product details and ability to add extra item to the basket-->
<div id="extraProductModal" class="modal" aria-modal [style]="{ 'z-index': 1 }">
    <div class="modal-dialog">
    <div class="modal-content">
    <div class="modal-header" [ngStyle]="{
              'justify-content': 'right',
              height: '40px',
              backgroundColor: (Merchant$ | async)?.webapp_settings?.menu_color,
              'border-bottom':
                (Merchant$ | async)?.webapp_settings?.menu_border_width +
                'px solid ' +
                (Merchant$ | async)?.webapp_settings?.menu_border_color,
            }">
        <span class="w-100" [ngStyle]="{
                color:
                  (Merchant$ | async)?.webapp_settings?.menu_font_color_homepgae ||
                  (Merchant$ | async)?.menu_font_color_homepgae,
                'text-align': 'left',
              }">Select from Options</span>
        <a (click)="close()" id="btnnotification" class="close-icon">
            <i [ngStyle]="{
                  color: (Merchant$ | async)?.webapp_settings?.menu_font_color_homepgae,
                }" class="zmdi zmdi-close zmdi-hc-fw"></i>
        </a>
    </div>

    <div class="modal-body">
        @if (
        pageModel?.selectedProduct != null &&
        pageModel?.selectedProduct?.extra_product
        ) {
        @for (
        extra_product of pageModel.selectedProduct.extra_product;
        track extra_product
        ) {
        <div class="custom-control custom-checkbox row">
            <div class="col-10">
                <input #checkboxes type="checkbox" class="custom-control-input" [id]="extra_product.id" [value]="extra_product.id"
                    [checked]="selectedExtras.includes(extra_product.id)" (change)="onExtraProductSelect($event, extra_product.id)" />
                <label class="custom-control-label ps-2" [for]="extra_product.id">
                    {{ extra_product.name }}
                </label>
                </div>

            <div class="col-2 justify-content-center align-self-center">
                <label [ngClass]="{ strikethrough: extra_product.is_discount }" [ngStyle]="{
                                    color: (Merchant$ | async)?.webapp_settings
                                      ?.menu_font_color_allpage,
                                  }">
                    {{ extra_product.price | currencyFormat: (Merchant$ | async)?.currency_decimals }}
                </label>

                @if (extra_product.is_discount) {
                <label [ngStyle]="{
                                      color: (Merchant$ | async)?.webapp_settings
                                        ?.menu_font_color_allpage,
                                    }">
                    {{ extra_product.discounted_price | currencyFormat: (Merchant$ | async)?.currency_decimals }}
                </label>
                }
                </div>
                </div>
                }
                }
                </div>

    <div class="modal-footer row m-0 row-cols-2">
        <div class="col m-0 d-grid">
        <button type="button" [ngStyle]="{
                      color: (Merchant$ | async)?.webapp_settings
                        ?.menu_font_color_homepgae,
                      backgroundColor: (Merchant$ | async)?.webapp_settings?.menu_color,
                      border:
                        (Merchant$ | async)?.webapp_settings?.menu_border_width +
                        'px solid ' +
                        (Merchant$ | async)?.webapp_settings?.menu_border_color,
                    }" class="btn btn-orange-light-theme btn-lg font-size-15" (click)="close()">
            Skip
        </button>
        </div>
        <div class="col m-0 d-grid">
        <button type="button" [ngStyle]="{
                      color: (Merchant$ | async)?.webapp_settings
                        ?.menu_font_color_homepgae,
                      backgroundColor: (Merchant$ | async)?.webapp_settings?.menu_color,
                      border:
                        (Merchant$ | async)?.webapp_settings?.menu_border_width +
                        'px solid ' +
                        (Merchant$ | async)?.webapp_settings?.menu_border_color,
                    }" class="btn btn-orange-light-theme btn-lg font-size-15"
            (click)="AddExtraProductToBasket()"
          >
            Add
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- New Modal for Limit Reached -->
<div id="limitReachedModal" class="modal" aria-modal [style]="{ 'z-index': 1050 }">
    <div class="modal-dialog">
        <div class="modal-content">
    <div class="modal-header" [ngStyle]="{
          'justify-content': 'right',
          height: '40px',
          backgroundColor: (Merchant$ | async)?.webapp_settings?.menu_color,
          'border-bottom':
            (Merchant$ | async)?.webapp_settings?.menu_border_width +
            'px solid ' +
            (Merchant$ | async)?.webapp_settings?.menu_border_color,
        }"
      >
        <span
          class="w-100"
          [ngStyle]="{
            color: (Merchant$ | async)?.webapp_settings
              ?.menu_font_color_homepgae,
            'text-align': 'left',
          }"
        >
          Selection Limit Reached
        </span>
        <a (click)="closeLimitReachedModal()" class="close-icon">
        <i [ngStyle]="{
                      color: (Merchant$ | async)?.webapp_settings?.menu_font_color_homepgae,
                    }" class="zmdi zmdi-close zmdi-hc-fw"></i>
        </a>
        </div>

    <div class="modal-body text-center">
        <p [ngStyle]="{
                    color: (Merchant$ | async)?.webapp_settings
                      ?.menu_font_color_allpage,
                  }">
            You can only select {{ limitValue }}
            {{ limitValue == 1 ? "item" : "items" }} with this product.
        </p>
        </div>

    <div class="modal-footer row m-0">
        <div class="col m-0 d-grid">
        <button type="button" [ngStyle]="{
                      color: (Merchant$ | async)?.webapp_settings
                        ?.menu_font_color_homepgae,
                      backgroundColor: (Merchant$ | async)?.webapp_settings?.menu_color,
                      border:
                        (Merchant$ | async)?.webapp_settings?.menu_border_width +
                        'px solid ' +
                        (Merchant$ | async)?.webapp_settings?.menu_border_color,
                    }" class="btn btn-orange-light-theme btn-lg font-size-15" (click)="closeLimitReachedModal()">
            OK
        </button>
        </div>
        </div>
        </div>
        </div>
</div>
